import { render, staticRenderFns } from "./ErrorNotFound.vue?vue&type=template&id=22cf2c9e&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cf2c9e",
  null
  
)

export default component.exports